import { toast } from 'react-toastify';
//styles
import "./styles.scss";

export const toastify = {
  success: (message: string, position?: any, timer?: number) =>
    toast.success(message, { position: position ?? "top-center", autoClose: timer ?? 2000 }),
  error: (message: string, position?: any, timer?: number) =>
    toast.error(message, { position: position ?? "top-center", autoClose: timer ?? 2000 })
};